import { useEffect, useState } from 'react';
import useDataApi from './useDataApi';
import config from '../config/config';

const useSearchCities = ( { submarket, stateAsLocation } ) => {
	const [ cache, setCache ] = useState( {} );
	const [ currentCities, setCurrentCities ] = useState( [] );
	const { data, isLoading, isError } = useDataApi(
		`${ config.API_ENDPOINT }search-data`,
		{ states: [], submarkets: [] },
	);

	useEffect( () => {
		if ( data.states.length === 0 ) {
			return;
		}
		setCache( data.states );
	}, [ data.states ] );

	// update currentCities when submarket changes
	useEffect( () => {
		if ( ! submarket.submarket || data.states.length === 0 ) {
			return;
		}
		const stateWithSubmarket = data.states.find( ( state ) => {
			return state.submarkets.find( ( sub ) => sub.name === submarket.submarket && state.name === submarket.state );
		} );
		const currentSubmarket = stateWithSubmarket.submarkets.find( ( sub ) => sub.name === submarket.submarket );
		if ( currentSubmarket ) {
			setCurrentCities( currentSubmarket.cities );
		}
	}, [ stateAsLocation.name, submarket.state, submarket.submarket, data.states ] );

	// update currentCities when stateAsLocation changes
	useEffect( () => {
		if ( ! stateAsLocation.name || data.states.length === 0 ) {
			return;
		}
		const currentState = data.states.find( ( sub ) => sub.name === stateAsLocation.name );
		setCurrentCities( currentState.cities );
	}, [ stateAsLocation.name, data.states ] );

	return { data, currentCities, isLoading, isError };
};

export default useSearchCities;
